import { atom } from "jotai";

export const pscAtom = atom<any>(null);
